<template lang="html">
    <div class="dropdown notifications-dropdown">
        <button @click="toggleNotifications" class="btn-notifications"
                ref="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" aria-labelledby="bell" role="presentation">
                <g fill="currentColor">
                    <path d="M7.997 14.498c-.34 0-.685-.087-1-.27-.302-.176-.553-.427-.727-.727-.139-.239-.057-.545.182-.684.24-.137.546-.057.684.183.087.149.213.275.364.364.476.276 1.088.112 1.365-.364.139-.241.445-.32.684-.182.239.139.32.445.182.684-.372.638-1.044.996-1.734.996zm7.503-2.247H.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5c.965 0 1.75-.785 1.75-1.75v-3.75c0-3.17 2.58-5.75 5.75-5.75 3.171 0 5.75 2.58 5.75 5.75v3.75c0 .965.785 1.75 1.75 1.75.276 0 .5.224.5.5s-.224.5-.5.5zm-12.88-1h10.76c-.394-.476-.63-1.086-.63-1.75v-3.75c0-2.619-2.131-4.75-4.75-4.75s-4.75 2.131-4.75 4.75v3.75c0 .664-.237 1.274-.63 1.75z" fill="#898c98">
                    </path>
                </g>
            </svg>
            <span class="notifications-count" v-if="notificationCount>0">{{notificationCount}}</span>
        </button>
        <transition name="fade">
            <dropdown-menu placement="right" :open.sync="showNotifications" v-click-outside="{
    exclude: ['button'],
    handler: 'onClose'
  }">
                <section class="notifications-list">
                    <template v-if="notifications !== null">
                        <ol>
                            <li v-for="notification in notifications" :key="notification.id">
                                <span class="user-id activities" v-bind:class="{'client-icon': notification.activity.isClientUser}">
                                    <span v-if="notification.activity.context">{{ notification.activity.context.byUserInitials }}</span>
                                </span>
                                {{notification.activity.message}}
                            </li>
                        </ol>
                    </template>
                    <footer>
                        <router-link to="/notifications">View all</router-link>
                    </footer>
                </section>
            </dropdown-menu>
        </transition>
    </div>
</template>

<script>

    import NotificationsServices from '../../services/notifications';
    import DropdownMenu from '../../helpers/DropdownMenu';
    import VuePusher from 'vue-pusher';

    export default {
        name: 'notifications-dropdown',
        components: {
            DropdownMenu,
        },
        data () {
            return {
                showNotifications: false,
                notificationCount: 0,
                notifications: null,
                pusherCount: `${process.env.VUE_APP_PUSHER}`
            }
        },
        mounted() {
            this.getNotificationsCount();
        },
        methods: {
            onClose() {
                this.showNotifications = false;
            },
            getNotificationsCount(){
                let pusher = new Pusher(this.pusherCount,{
                    cluster: 'ap4',
                    forceTLS: true
                });
                let channel = pusher.subscribe('notifications-channel');
                let obj = this;
                channel.bind('notifications-pushed', function(data) {
                    let username =JSON.parse(localStorage.getItem('user'))["username"];
                    obj.notificationCount = data[username];
                });
            },
            toggleNotifications() {
                this.showNotifications = !this.showNotifications;
                if (this.showNotifications) {
                    NotificationsServices.getTopActivities().then(
                        activities => {
                            this.notifications = activities.data;
                            this.notificationCount = 0;
                        }
                    );

                }

            }
        }
    }
</script>
